import React from 'react';
import classes from './style.module.scss';
import Logo from '../Logo/Logo';

const Reviews = () => {
    return (
        <div className={classes.container}>
            <div>
                <h2>Что о нас говорят</h2>
                <Logo />
            </div>
            <div className={classes.reviewContainer}>
                <iframe src="https://yandex.ru/maps-reviews-widget/204861316326?comments"></iframe>
                <a
                    href="https://yandex.ru/maps/org/legenda/204861316326/"
                    target="_blank"
                    rel="noreferrer"
                >
                    Легенда на карте Ногинска — Яндекс.Карты
                </a>
            </div>
        </div>
    );
};

export default Reviews;
